import { css } from '@emotion/react'
import common from 'shared/styles'

const styles = () => {
    return {
        root: css`
            ${common.fullContainer};
            display: flex;
            flex-direction: column;
        `,
        buttons: css`
            ${common.flexJustityAlignCenter};
            flex-grow: 0;
            padding-bottom: 20px;
        `,
        button: common.stepsPictureButton,
        noPictureText: css` padding: 20px `,
        context: css` display: flex `,
        deleteButton: css`
            padding: 0;
            padding-top: 10px;
            align-self: start;
        `,
    }
}

export default styles
